import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Card from './Card';
import CardCtaButton from './CardCtaButton';
import CardTop from './CardTop';

const Provider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 156px;
  max-width: 200px;
  padding: 8px 20px;
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
  background-color: ${({ theme }) => theme.white};
`;

const ProviderText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Content = styled.div`
  align-content: flex-start;
  box-sizing: border-box;
  width: 100%;
`;

const StyledTitle = styled.h2`
  display: flex;
  align-items: center;
  padding: 20px 25px 0 25px;
  font-size: 1.125rem;
`;

const Description = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  padding: 0 25px 50px 25px;
`;

function ServiceCard({
  service: { serviceProvider, coverPhoto, title, description, link },
}: {
  service: {
    serviceProvider: string;
    coverPhoto: string;
    title: string;
    description: string;
    link: string;
  };
}) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardTop backgroundImage={coverPhoto}>
        <Provider>
          <ProviderText>{serviceProvider}</ProviderText>
        </Provider>
      </CardTop>

      <Content>
        <StyledTitle>{title}</StyledTitle>
        <Description>{description}</Description>
      </Content>
      <CardCtaButton as="a" href={link} target="_blank">
        {t('card.openLink')}
      </CardCtaButton>
    </Card>
  );
}

export default ServiceCard;
